module.exports = __webpack_public_path__ + "static/af0f424b.highLight.png";